"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTelemetryClient = void 0;

var _TelemetryClient = require("./TelemetryClient");

let clientSingleton = null;

const getTelemetryClient = (...opts) => {
  if (!clientSingleton && typeof window !== 'undefined') {
    clientSingleton = new _TelemetryClient.TelemetryClient(...opts);
  }

  return clientSingleton;
};

exports.getTelemetryClient = getTelemetryClient;